<template>
  <Page :page-name="pageName" :table="table" :pagination="pagination" :search-bar="searchBar" @selectedRows="selectedRows"
  v-loading="loading" element-loading-text="数据加载中" element-loading-background="rgba(255, 255, 255, 0.5)">
    <div slot="operate-bar" class="operate-bar">
      <el-button type="primary" @click="clickNewPage">添加</el-button>
      <!-- <el-button type="primary" @click="delTableMulti">批量删除</el-button> -->
    </div>
    <template slot="table-operate" slot-scope="{scope}">
      <el-button v-if="scope.realname!=='admin'" type="text" style="margin-right: 20px"  @click="edit(scope)">
        编辑
      </el-button>
      <el-button  type="text" :class="scope.isAdmin? 'admin': ''" style="margin-right: 20px" @click="resetPassword(scope)">
        重置密码
      </el-button>

      <el-button v-if="!scope.isAdmin" type="text" @click="deleteItem([scope.userId])" style="color: #f33458; cursor: pointer;">
        删除
      </el-button>
    
      <!-- <el-button v-else type="text" style="color: transparent">1801</el-button> -->
    </template>
    <Dialogs :title="pageTitle" :is-show-dialog="isShowPage" width="26%" @handleClick="handleClose">
      <div slot="content">
        <AccoutDetail
          ref="accountDetailRef"
          :row-form="rowData"
          :readonly="readonly"
          :role-name-data="roleNameData"
          :page-flag="String(pageFlag)"
          :is-create="isCreate"
        />
      </div>
      <div slot="btns">
        <div v-if="readonly">
          <el-button @click="cancel">关闭</el-button>
        </div>
        <div v-else>
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="clickPage">保 存</el-button>
        </div>
      </div>
    </Dialogs>
  </Page>
</template>

<script>
import Page from '@/components/Page.vue'
import AccoutDetail from './accoutDetail'
import {getUserList, createUser, updateUserInfo, resetPassword, deleteUser} from '@/api/userManager'
import {getRoleList} from '@/api/role'
import variables from '@/styles/variables.scss'
import Dialogs from '@/components/page/Dialogs.vue'

export default {
  name: 'Account',
  components: {
    AccoutDetail,
    Page,
    Dialogs
  },
  data () {
    return {
      pageName: '用户管理',
      table: {
        selection: true, // 是否开启选择框
        tableInfo: [{
          key: 'num',
          name: '序号',
          minWidth: 30
        }, {
          key: 'username',
          name: '员工账号',
          minWidth: 80
        }, {
          key: 'realname',
          name: '姓名',
          minWidth: 60
        }, {
          key: 'roleName',
          name: '角色',
          minWidth: 60
        }, {
          key: 'mobile',
          name: '手机号',
          minWidth: 80
        }],
        tableData: [],
        deleteItem: this.deleteItem,
        deleteList: () => {
          this.delTableMulti()
        }
      },
      pagination: {
        total: 0,
        currentPage: 1,
        size: 10,
        currentChange: (page) => {
          this.handleCurrentChange(page)
        },
        sizeChange: (size) => {
          this.handleSizeChange(size)
        }
      },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'username',
          label: '账号',
          placeholder: '请输入账号'
        }, {
          type: 'input',
          prop: 'realname',
          label: '姓名',
          placeholder: '请输入姓名'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: this.searchBarform
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      params: {
        realname: ''
      },

      accountForm: {
        realname: '',
        realName: ''
      },
      multipleSelection: [],
      isShowPage: false,
      pages: 0,
      currentRow: undefined,
      readonly: false,
      pageFlag: null, // 查看1 编辑2 新建3
      roleNameData: [],
      selectionRows: [],
      tableHeight: 300,
      rowData: null,
      isCreate: false,
      userIds: [],
      isAdmin: sessionStorage.username === 'admin',  // 登录者是否是管理员
      loading: false,
      ms: null
    }
  },
  computed: {
    pageTitle () {
      let name = this.readonly ? '查看' : this.currentRow ? '编辑' : '添加'
      this.pageFlag = this.currentRow ? 2 : 3
      return name
    },
    variables () {
      return variables
    },
    username () {
      return sessionStorage.username
    }
  },
  mounted () {
    this.getUserList()
    this.getRoleNameList()
  },
  methods: {
    getUserList (val) {
      let params = {
        current: this.pagination.currentPage,
        size: this.pagination.size
      }
      if (val) {
        params = {
          ...params,
          ...val
        }
      }
      this.loading = true
      getUserList(params).then(({success, data}) => {
        if (success) {
          const {pages, records, total} = data
          this.pages = pages
          this.pagination.total = total
          this.table.tableData = records.map(item => ({ ...item, id: item.userId }))
          this.table.tableData.forEach((item, idx) => {
            item.accountStatus = item.status === '1'
            item.num = (this.pagination.currentPage - 1) * 10 + idx + 1
          })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    resetList () {
      this.pagination.currentPage = 1
      this.getUserList()
    },
    getRoleNameList () {
      getRoleList().then(({success, data}) => {
        if (success) {
          this.roleNameData = data.map((item) => ({
            roleId: item.roleId,
            roleName: item.roleName
          }))
        }
      })
    },

    handleSelectionChange (selection) {
      this.selectionRows = selection
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getUserList(this.accountForm)
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.getUserList()
    },
    clearInput () {
      this.getUserList()
    },
    clickNewPage () {
      this.isShowPage = true
      this.currentRow = undefined
      this.readonly = false
      this.isCreate = true
      window.addEventListener('keyup', this.handleKeyUp)
    },
    resetPassword (row) {
      this.$confirm('重置密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          const params = {
            userId: row.userId
          }
          resetPassword(params).then(({success}) => {
            success && this.$message({
              type: 'success',
              message: '重置成功!'
            })
          })
        })
    },
    selectedRows (rows) {
      this.userIds = rows.map(item => item.userId)
    },
    deleteItem (userIds) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          this.delete(userIds)
        })
    },
    delete (userId) {
      deleteUser(userId).then(({success}) => {
        if (success) {
          if (this.table.tableData.length === userId.length && this.pagination.currentPage > 1) this.pagination.currentPage -= 1
          this.getUserList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }
      })
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.$nextTick(() => {
        this.getUserList(this.params)
      })
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.$nextTick(() => {
        this.getUserList(this.params)
      })
    },
    edit (row) {
      this.currentRow = row
      this.rowData = row
      this.isShowPage = true
      window.addEventListener('keyup', this.handleKeyUp)
    },

    handleClose () {
      this.cancel()
    },
    cancel () {
      this.isShowPage = false
      this.rowData = null
      this.isCreate = false
      window.removeEventListener('keyup', this.handleKeyUp)
    },
    clickPage () {
      if (this.pageFlag === 1) return
      const apiName =
        this.pageFlag === 2 ? updateUserInfo : createUser
      const message = this.pageFlag === 2 ? '更新' : '新建'
      const data = this.isCreate
        ? this.$refs.accountDetailRef.rowData
        : this.$refs.accountDetailRef._props.rowForm
      const refForm = this.$refs.accountDetailRef.$refs.rowForm
      refForm.validate((valid) => {
        if (valid) {
          const {
            username,
            password,
            realname,
            roleId,
            mobile,
            status
            } = data
          const params = {
            username,
            password,
            realname,
            mobile,
            status,
            roleId,
            userId: this.pageFlag === 2 ? data.userId : undefined
          }

          apiName(params).then(({success}) => {
            if (success) {
              this.$message({
                type: 'success',
                message: `${message}用户成功`
              })
              this.getUserList()
            }
            this.cancel()
          })
        }
      })
    },
    searchBarform (params) {
      // eslint-disable-next-line standard/object-curly-even-spacing
      this.ms && this.ms.close()
      this.params = { ...this.params, ...params, realname: params.realname.trim(), username: params.username.trim()}
      const {realname, username} = this.params
      if ((realname && realname.length > 30) || (username && username.length > 30)) {
        this.ms = this.$message({
          type: 'warning',
          message: '搜索的长度不能超过30字'
        })
        return
      }
      this.pagination.currentPage = 1
      this.getUserList(this.params)
    },
    // 用户配置
    delTableMulti () {
      if (!this.userIds.length) {
        this.$message.warning('请选择账号')
        return
      }
      this.deleteItem(this.userIds).then(({success}) => {
        if (success) {
          this.userIds = []
        }
      })
    },
    handleKeyUp (event) {
      if (event.key === 'Enter') {
        this.clickPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep  .el-table {
  height: calc(100% - 46px);
}
::v-deep  .el-table__body-wrapper{
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  height: calc(100% - 32px);
  overflow-y: auto;
}
::v-deep .pagination-container{
  padding: 0;
}
::v-deep .el-button {
  padding: 0 12px;
  height: 36px;
}
.admin {
  margin-right: 0 !important;
}
</style>
